import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MultiQuoteUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getMultiQuoteDetails(req);
    }
}
export default MultiQuoteUseCase;
